export type S1AutoModeStepKey = "S1_CAPTURE" | "S1_COLLECT" | "S1_RENDER" | "S1_OCR" | "S1_SIGNALS" | "S1_AI" | "S1_4";

export function getS1AutoModeStepSequence(
  flyerCaptureMode: string | null | undefined,
): S1AutoModeStepKey[] {
  if (flyerCaptureMode === "IMAGE_CAPTURE") {
    return ["S1_CAPTURE", "S1_OCR", "S1_SIGNALS", "S1_AI", "S1_4"];
  }
  return ["S1_COLLECT", "S1_RENDER", "S1_OCR", "S1_SIGNALS", "S1_AI", "S1_4"];
}

